import React from 'react';
import moment from 'moment';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {formatProviderName} from '../../helpers/providers';
import { 
  getEventBlocks, 
  getAvailabilityBlocks 
} from './calendarUtils';

import CustomBox from '../common/CustomBox';
import ProviderAvatar from '../providers/ProviderAvatar';
import CalendarDayView from './CalendarDayView';

const OneProviderSchedule = ({
  date,
  provider,
  sessions = [],
  awayTimes = [],
  availabilities = [],
  onDateChange,
  startHour = 8,
  endHour = 20,
}) => {
  console.log('AVAILABILITIES', availabilities);
  const calendarView = 'day';
  const awayTimeBlocks = (
    awayTimes && awayTimes.length
    ? getEventBlocks({
        timeStart: moment(date).startOf(calendarView).toISOString(),
        timeEnd: moment(date).endOf(calendarView).toISOString(),
        startHour,
        endHour,
      })(awayTimes.filter(at => at.provider_id === provider.id))
    : []
  );
  const availabilityBlocks = (
    availabilities && availabilities.length
    ? getAvailabilityBlocks({ date, startHour, endHour })(availabilities.filter(a => a.provider_id === provider.id))
    : []
  );
  return (
    <Box key={provider.id}>
      <Box 
        style={{
          border: '1px solid rgb(225,225,225)',
          borderRadius: '10px',
          marginTop: '1em',
          marginBottom: '1em',
          padding: '1em',
          background: 'rgb(250,250,250)',
          width: '100%',
        }}
      >
        <Stack spacing={1} alignItems="center">
          <ProviderAvatar provider={provider} />
          <Typography variant='h2'>
            {formatProviderName(provider)}
          </Typography>
        </Stack>
      </Box>
      <CustomBox>
        <CalendarDayView
          date={date}
          sessions={sessions.filter(s => s.provider.id === provider.id)}
          awayTimeBlocks={awayTimeBlocks}
          availabilityBlocks={availabilityBlocks}
          onDateChange={onDateChange}
        />
      </CustomBox>
    </Box>
  );
};

export default OneProviderSchedule;

